function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "m343.58-477.68 60.7 8.52c-3.24-13.73-13.2-22.6-30.15-25.36l-30.56 16.84z"
}));

var _ref2 = /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "m221.03-362.1-4.33 51.56c8.17 11.16 19.4 12.13 31.2 11.26-8.53-21.23-25.57-63.68-26.87-62.82z"
}));

var _ref3 = /*#__PURE__*/React.createElement("clipPath", {
  id: "c"
}, /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "m271.5-373.63 30.56 58.96c18.07-9.8 32.22-21.74 45.18-34.53z"
}));

var _ref4 = /*#__PURE__*/React.createElement("clipPath", {
  id: "d"
}, /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "m328.35-426.28 53.85 32.98c1.12.63 15.3-23.93 18.53-37.8l-72.38 4.83z"
}));

var _ref5 = /*#__PURE__*/React.createElement("clipPath", {
  id: "e"
}, /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "m401.12-430.9c7.8-23.54 9.6-57.3-27.18-63.58l-30.18 16.67 57.36 46.9z"
}));

var _ref6 = /*#__PURE__*/React.createElement("clipPath", {
  id: "f"
}, /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "m328.24-426.4 19.5 77.2c22.93-24.1 43.5-50.03 53.6-82.1l-73.08 4.9z"
}));

var _ref7 = /*#__PURE__*/React.createElement("clipPath", {
  id: "g"
}, /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "m248.68-297.9 22.86-75.72 75.92 24.4c-27.45 25.74-57.98 47.5-98.78 51.33z"
}));

var _ref8 = /*#__PURE__*/React.createElement("clipPath", {
  id: "h"
}, /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "m250-453.24c29.43-29.18 67.37-46.42 81.93-31.73 14.55 14.7-.88 50.4-30.3 79.56s-66.9 47.36-81.45 32.67c-14.56-14.68.4-51.33 29.83-80.5z"
}));

var _ref9 = /*#__PURE__*/React.createElement("clipPath", {
  id: "i"
}, /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "m210.38-393.67-2.7 56.47 14.13-25.77z"
}));

var _ref10 = /*#__PURE__*/React.createElement("clipPath", {
  id: "j"
}, /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "m319.17-494.77 55 .25-33.73 18.64-21.28-18.9z"
}));

var _ref11 = /*#__PURE__*/React.createElement("clipPath", {
  id: "k"
}, /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "m327.68-426.2 73.32-4.8-57.35-46.84-15.97 51.63z"
}));

var _ref12 = /*#__PURE__*/React.createElement("clipPath", {
  id: "l"
}, /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "m266-375.28 81.87 26.17-21.2-83.04z"
}));

var _ref13 = /*#__PURE__*/React.createElement("clipPath", {
  id: "m"
}, /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "m221.02-362.52 27.66 64.64 23.04-75.48z"
}));

var _ref14 = /*#__PURE__*/React.createElement("clipPath", {
  id: "n"
}, /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "m248.55-297.9 146.4-9.85-92.25-7.25-54.16 17.1z"
}));

var _ref15 = /*#__PURE__*/React.createElement("clipPath", {
  id: "o"
}, /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "m347.9-349.36 46.88 41.6-12.6-86.9-34.3 45.28z"
}));

var _ref16 = /*#__PURE__*/React.createElement("clipPath", {
  id: "p"
}, /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "m248.06-297.7 146.47-9.94 11.28-147.7-44.63 90.46-113.12 67.17z"
}));

var _ref17 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "q",
  spreadMethod: "pad",
  x1: 381.75,
  x2: 339.95,
  xlinkHref: "none",
  y1: -279.745,
  y2: -353.545
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fb7655"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.41,
  stopColor: "#e42b1e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#900"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#900"
}));

var _ref18 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "r",
  spreadMethod: "pad",
  x1: 402.574,
  x2: 348.705,
  xlinkHref: "none",
  y1: -341.734,
  y2: -377.883
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#871101"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#911209"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#911209"
}));

var _ref19 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "s",
  spreadMethod: "pad",
  x1: 359.474,
  x2: 305.605,
  xlinkHref: "none",
  y1: -277.507,
  y2: -313.656
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#871101"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#911209"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#911209"
}));

var _ref20 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "t",
  spreadMethod: "pad",
  x1: 246.376,
  x2: 254.727,
  xlinkHref: "none",
  y1: -367.898,
  y2: -313.625
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.23,
  stopColor: "#e57252"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46,
  stopColor: "#de3b20"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#a60003"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#a60003"
}));

var _ref21 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "u",
  spreadMethod: "pad",
  x1: 303.813,
  x2: 306.89,
  xlinkHref: "none",
  y1: -418.579,
  y2: -363.189
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.23,
  stopColor: "#e4714e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#be1a0d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#a80d00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#a80d00"
}));

var _ref22 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "v",
  spreadMethod: "pad",
  x1: 354.784,
  x2: 363.995,
  xlinkHref: "none",
  y1: -469.767,
  y2: -430.072
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#e46342"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#c82410"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#a80d00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#a80d00"
}));

var _ref23 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "w",
  spreadMethod: "pad",
  x1: 326.656,
  x2: 366.35,
  xlinkHref: "none",
  y1: -483.748,
  y2: -503.595
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#c81f11"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#bf0905"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#bf0905"
}));

var _ref24 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "x",
  spreadMethod: "pad",
  x1: 211.584,
  x2: 214.851,
  xlinkHref: "none",
  y1: -381.735,
  y2: -349.025
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.31,
  stopColor: "#de4024"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#bf190b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#bf190b"
}));

var _ref25 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "y",
  spreadMethod: "pad",
  x1: 189.12,
  x2: 342.694,
  xlinkHref: "none",
  y1: -340.181,
  y2: -498.098
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#bd0012"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.07,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.27,
  stopColor: "#c82f1c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#820c01"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46,
  stopColor: "#a31601"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#b31301"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#e82609"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#e82609"
}));

var _ref26 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "z",
  spreadMethod: "pad",
  x1: 306.757,
  x2: 260.503,
  xlinkHref: "none",
  y1: -324.257,
  y2: -335.673
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8c0c01"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#990c00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#a80d0e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#a80d0e"
}));

var _ref27 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "A",
  spreadMethod: "pad",
  x1: 386.206,
  x2: 345.112,
  xlinkHref: "none",
  y1: -379.776,
  y2: -416.608
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7e110b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#9e0c00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9e0c00"
}));

var _ref28 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "B",
  spreadMethod: "pad",
  x1: 401.303,
  x2: 380.833,
  xlinkHref: "none",
  y1: -447.354,
  y2: -469.237
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#79130d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#9e120b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9e120b"
}));

var _ref29 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "C",
  cx: 351.50977,
  cy: -415.8999,
  r: 50.36,
  spreadMethod: "pad",
  xlinkHref: "none"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#a80d00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#7e0e08"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7e0e08"
}));

var _ref30 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "D",
  cx: 281.77002,
  cy: -349.54004,
  r: 66.9469,
  spreadMethod: "pad",
  xlinkHref: "none"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#a30c00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#800e08"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#800e08"
}));

var _ref31 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "E",
  spreadMethod: "pad",
  x1: 234.351,
  x2: 217.669,
  xlinkHref: "none",
  y1: -297.951,
  y2: -354.548
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8b2114"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.43,
  stopColor: "#9e100a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#b3100c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b3100c"
}));

var _ref32 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "F",
  spreadMethod: "pad",
  x1: 362.323,
  x2: 399.723,
  xlinkHref: "none",
  y1: -485.492,
  y2: -468.983
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b31000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#910f08"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#791c12"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#791c12"
}));

var _ref33 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  transform: "matrix(.1620975 0 0 .1620975 -33.66791918966 80.2861671354)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#p)",
  d: "m248.06-297.7 146.47-9.94 11.28-147.7-44.63 90.46-113.12 67.17z",
  fill: "url(#q)"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#o)",
  d: "m347.9-349.36 46.88 41.6-12.6-86.9-34.3 45.28z",
  fill: "url(#r)"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#n)",
  d: "m248.55-297.9 146.4-9.85-92.25-7.25-54.16 17.1z",
  fill: "url(#s)"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#m)",
  d: "m221.02-362.52 27.66 64.64 23.04-75.48z",
  fill: "url(#t)"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#l)",
  d: "m266-375.28 81.87 26.17-21.2-83.04z",
  fill: "url(#u)"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#k)",
  d: "m327.68-426.2 73.32-4.8-57.35-46.84-15.97 51.63z",
  fill: "url(#v)"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#j)",
  d: "m319.17-494.77 55 .25-33.73 18.64-21.28-18.9z",
  fill: "url(#w)"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#i)",
  d: "m210.38-393.67-2.7 56.47 14.13-25.77z",
  fill: "url(#x)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m209.62-394.64 11.5 32.62 49.97-11.2 57.05-53.02 16.1-51.14-25.35-17.9-43.1 16.13-40.88 38.1c-.94.48-17.4 31.6-25.3 46.43z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#h)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m250-453.24c29.43-29.18 67.37-46.42 81.93-31.73 14.55 14.7-.88 50.4-30.3 79.56s-66.9 47.36-81.45 32.67c-14.56-14.68.4-51.33 29.83-80.5z",
  fill: "url(#y)"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#g)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m248.68-297.9 22.86-75.72 75.92 24.4c-27.45 25.74-57.98 47.5-98.78 51.33z",
  fill: "url(#z)"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#f)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m328.24-426.4 19.5 77.2c22.93-24.1 43.5-50.03 53.6-82.1l-73.08 4.9z",
  fill: "url(#A)"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#e)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m401.12-430.9c7.8-23.54 9.6-57.3-27.18-63.58l-30.18 16.67 57.36 46.9z",
  fill: "url(#B)"
})), /*#__PURE__*/React.createElement("path", {
  d: "m207.68-337.54c1.08 38.85 29.1 39.43 41.05 39.77l-27.58-64.4-13.47 24.64z",
  fill: "#9e1209"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m328.35-426.28 53.85 32.98c1.12.63 15.3-23.93 18.53-37.8l-72.38 4.83z",
  fill: "url(#C)"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#c)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m271.5-373.63 30.56 58.96c18.07-9.8 32.22-21.74 45.18-34.53z",
  fill: "url(#D)"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m221.03-362.1-4.33 51.56c8.17 11.16 19.4 12.13 31.2 11.26-8.53-21.23-25.57-63.68-26.87-62.82z",
  fill: "url(#E)"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m343.58-477.68 60.7 8.52c-3.24-13.73-13.2-22.6-30.15-25.36l-30.56 16.84z",
  fill: "url(#F)"
}))));

const SvgRuby = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  height: 64,
  viewBox: "0 0 32 32",
  width: 64,
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRuby, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ruby.75a7deda.svg";
export { ForwardRef as ReactComponent };